import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ClientesService } from 'src/app/services/clientes/clientes.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { LoadingEfectComponent } from 'src/app/Layout/loading-efect/loading-efect.component';
import { UsuariosService } from 'src/app/services/usuarios/usuarios.service';

@Component({
  selector: 'app-alerta-co',
  templateUrl: './alerta-co.component.html',
  styleUrls: ['./alerta-co.component.css']
})
export class AlertaCoComponent implements OnInit {
  loading = new LoadingEfectComponent();
  identity = JSON.parse(localStorage.getItem('identity_user'));
  public ItemId = +this._route.snapshot.paramMap.get('id');
  public tipoAlerta:number = 0;
  public cuestionario: any = [];
  searchClient;
  public todayDate:any = new Date();
  public titleAlerta:string = "";

  constructor(
    private _service:ClientesService,
    private _route: ActivatedRoute,
    public _router: Router,
    private _serviceUsuario:UsuariosService,
  ) { }

  ngOnInit(){
    this._route.paramMap.subscribe((params: ParamMap) => {
      this.ItemId = +params.get('id');
      if(this.ItemId == 5){
        this.tipoAlerta = 4;
        this.titleAlerta = "Pendientes >";
      }
      else if(this.ItemId == 4){
        this.tipoAlerta = 4;
        this.titleAlerta = "Pendientes >";
      }
      else if(this.ItemId == 2){
        this.tipoAlerta = 5;
        this.titleAlerta = "Por Caducar >";
      }
      else if(this.ItemId == 3){
        this.tipoAlerta = 6;
        this.titleAlerta = "Caducados >";
      }
      this.getItems(this.ItemId);
      this.registrarLog();
    });
  }

  public registrarLog(){
    let clase = 'Alertas ' + this.titleAlerta + ' Empresas';
    let obj = {
      //Controller: obj.Controller,
      Class: clase,
      //Table: obj.Table,
      //ID: obj.ID,
      Message: 'ACCESO'
    }
    this._serviceUsuario.registrarLog(obj);
  }

  public getItems(tipo:number){    
    this._service.getEmpresaAlerta(tipo).then(response=>{     
      this.cuestionario = response.content;
      console.log(response.content);
    })
    .catch(error => {      
      console.log(error.toString());
    });
  }
}
